<template>
    <div id="custom-conditions">
        <div class="row mb-2">
            <div class="col-12">
                <label>
                    {{resource('JourneyComposer_BrickSettingsTouchpoint_Custom_Conditions_Header')}}
                </label>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-12">
                <button class="btn btn-outline-secondary" @click="addCondition" :disabled="parentType === ''">
                    <i class="fas fa-plus"></i> {{resource('Button_Add')}}
                </button>
            </div>
        </div>
        <custom-condition v-for="condition in newValue" 
            :key="condition.id"
            :canWrite="canWrite"
            :parentType="parentType"
            :value="condition"

            @delete="removeCondition($event)"
        />
    </div>
</template>

<script>

import CustomCondition from './TouchpointCustomField.vue';
import resources from '../../../../../../Util/Mixins/resources';
import guid from '../../../../../../Util/Mixins/guid';

export default {
    name: 'touchpoint-custom-conditions',
    mixins: [resources, guid],
    components: {
        CustomCondition
    },
    created() {
        this.newValue = this.value;
    },
    methods: {
        addCondition() {
            this.newValue.push({
                id: this.guid(),
                type: undefined,
                value: ''
            });
        },
        removeCondition(id) {
            const condition = this.newValue.find((item) => item.id == id);
            this.newValue.splice(this.newValue.indexOf(condition), 1);
        }
    },
    watch: {
        newValue: {
            handler: function(value) {
                this.$emit('input', value);
            },
            deep: true
        }
    },
    data() {
        return {
            newValue: []
        }
    },
    props: {
        value: {
            type: Array,
            default: () => {
                return [];
            }
        },
        parentType: {
            type: String,
            required: true
        },
        canWrite: {
            type: Boolean,
            required: true
        }
    }
};
</script>

<style>

</style>